<template>
  <section>
    <mdb-btn color="primary" @click.native="openServiceForm()">
      Add New Service
    </mdb-btn>
    <Table :headers="tableHeaders" title="Services">
      <tbody slot="rows">
        <tr v-for="(row, index) in tableRows" :key="index">
          <td>
            <a @click="openServiceForm(row)">{{ row.name }}</a>
          </td>
          <td v-if="row.isActive">
            Yes
          </td>
          <td v-else>
            No
          </td>
          <td>{{ row.createdAt }}</td>
        </tr>
      </tbody>
    </Table>
    <mdb-modal :show="showModal" size="lg" @close="closeServiceForm()">
      <mdb-modal-header>
        <mdb-modal-title>{{ modalTitle }}</mdb-modal-title>
      </mdb-modal-header>
      <validated-form :message="formMessage" @submit="handleFormSubmit">
        <mdb-modal-body>
          <mdb-input v-model="serviceForm.name"
                     size="lg"
                     label="Service Name"
                     type="text"
                     validate
                     outline
                     required
          />
          <div class="form-check">
            <input
              id="isActiveCheckbox"
              v-model="serviceForm.isActive"
              type="checkbox"
              class="form-check-input"
            />
            <label class="form-check-label pl-2" for="isActiveCheckbox">Is Active?</label>
          </div>
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn v-if="activeServiceId" color="red" type="button" @click.native="deleteService()">
            Delete
          </mdb-btn>
          <mdb-btn color="primary" type="submit">
            Save
          </mdb-btn>
        </mdb-modal-footer>
      </validated-form>
    </mdb-modal>
  </section>
</template>

<script>
import {
  mdbInput,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn
} from "mdbvue";
import ValidatedForm from "@/components//ValidatedForm";
import Table from "@/components//Table";
import { servicesModel } from "../models/service";

export default {
  name: "Services",
  components: {
    mdbInput,
    mdbBtn,
    ValidatedForm,
    Table,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter
  },
  data() {
    return {
      showModal: false,
      modalTitle: "Create Service",
      tableHeaders: ["Service", "Is Active?", "Date Added"],
      tableRows: [],
      activeServiceId: "",
      formMessage: {},
      serviceForm: {
        name: "",
        isActive: true
      }
    };
  },
  beforeMount() {
    this.getServices();
  },
  methods: {
    openServiceForm(service) {
      this.modalTitle = "Create Service";
      if (service) {
        this.activeServiceId = service.id;
        this.serviceForm.name = service.name;
        this.serviceForm.isActive = service.isActive;
        this.modalTitle = "Update Service";
      }
      this.showModal = true;
    },
    clearServiceForm() {
      this.activeServiceId = "";
      this.serviceForm = {
        name: "",
        isActive: true
      };
    },

    closeServiceForm() {
      this.showModal = false;
      this.clearServiceForm();
      this.getServices();
    },

    getServices() {
      this.tableRows = [];
      return servicesModel.list("name").then(services => {
        services.forEach(service => {
          this.tableRows.push(service);
        });
      });
    },
    handleFormSubmit() {
      this.formMessage = {};
      const promise = this.activeServiceId ? this.updateService : this.saveService;
      promise()
        .catch(() => {
          this.formMessage = {
            type: "danger",
            message: "There was a problem updating. Please try again"
          };
        });
    },
    saveService() {
      return servicesModel
        .create({
          name: this.serviceForm.name.trim(),
          isActive: this.serviceForm.isActive
        })
        .then(() => {
          this.closeServiceForm();
        });
    },

    updateService() {
      return servicesModel
        .update(this.activeServiceId, {
          name: this.serviceForm.name.trim(),
          isActive: this.serviceForm.isActive
        })
        .then(() => {
          this.closeServiceForm();
        });
    },

    deleteService() {
      return servicesModel.remove(this.activeServiceId)
        .then(() => {
          this.closeServiceForm();
        });
    }
  }
};
</script>

